import { Link } from '@atlassian/amkt-common';
import React from 'react';

var ExternalLink = function ExternalLink(props) {
  return /*#__PURE__*/React.createElement(Link, {
    className: props.className,
    href: props.href,
    target: "_blank",
    rel: "noopener noreferrer",
    onClick: props.onClick,
    title: props.title,
    "data-testid": props['data-testid']
  }, props.children);
};

export default ExternalLink;